<template>
    <div class="personal_center">
        <div class="warp1200 fix">
            <PersonalCenterMenu :activeIndex="7" />
            <div class="f-fr center_right">
                <contact-list></contact-list>

                <!-- 航线推荐 -->
                <promo-cruise></promo-cruise>
            </div>
        </div>
    </div>
</template>

<script>
    import PersonalCenterMenu from '@/components/User/PersonalCenterMenu'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import ContactList from '@/components/User/ContactList'

    export default {
        name: 'UserContact',
        components: {
            PersonalCenterMenu,
            PromoCruise,
            ContactList,
        },
        beforeMount() {
            this.init()
        },
        methods: {
            init () {
                const userToken = this.$store.state.user.userToken
                if (!userToken) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return false
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .personal_center {
        background-color: #f5f5f5;
        .center_right{
            width: 945px;
            margin-top: 20px;
        }
    }
</style>
